/**
 * This is the forgotten module configuration.
 * Do NOT configure routes in this file.
 * @memberOf Forgotten Module
 * @namespace Forgotten Config
 */

/**
 * @name config
 * @desc Configures the module.
 * @memberOf Forgotten Module.Forgotten Config
 * @ngInject
 */
var config = function () {
}

export default config;


// WEBPACK FOOTER //
// ./src/login/forgotten/forgotten.config.js